import { CommonModule } from '@angular/common';
import { AboutComponent } from './about.component';
import { NgModule } from '@angular/core';
import { AboutRoute } from './about.route';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared';

@NgModule({
    declarations: [AboutComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [AboutRoute]
        })
    ]
})
export class AboutModule {}
